<!--
 * @Description: 运维管理 业务中台 订单同步记录列表
-->
<template>
  <scroll-layout class="order-sync-record-list">
    <template slot="header">
      <ykc-search
        ref="YkcSearch"
        :data="searchData"
        :searchForm="searchParams"
        @click="handleSearchConfirm"
        @clean="handleSearchClean"></ykc-search>
    </template>
    <div>
      <ykc-table
        ref="YkcTable"
        operateFixedType="right"
        :data="tableData"
        :title="tableTitle"
        :columns="tableColumns"
        :operateButtons="tableOperateButtons.filter(item => item.enabled())">
        <ykc-pagination
          align="right"
          slot="pagination"
          ref="YkcPagination"
          :total="pageInfo.total"
          :page-size.sync="pageInfo.size"
          :current-page.sync="pageInfo.current"
          @size-change="handlePaginationSizeChange"
          @current-change="handlePaginationCurrentChange"></ykc-pagination>
      </ykc-table>
    </div>
  </scroll-layout>
</template>

<script>
  import { businessPlatform } from '@/service/apis';
  import { code, offlineExport } from '@/utils';

  export default {
    name: 'orderSyncRecordList',
    data() {
      return {
        searchParams: {
          // 查询参数
        },
        // 列表表格
        tableTitle: '订单同步记录',
        tableData: [],
        tableOperateButtons: [], // 列表操作
        tableColumns: [
          { label: '同步批次ID', prop: 'id', minWidth: '150px' },
          {
            label: '数据来源',
            prop: 'platformType',
            minWidth: '100px',
            scopedSlots: {
              default: ({ row }) => this.getPlatformTypeText(row.platformType),
            },
          },
          { label: '数据范围开始时间', prop: 'startTime', minWidth: '250px' },
          { label: '数据范围结束时间', prop: 'endTime', minWidth: '250px' },
          { label: '数据量', prop: 'successNums', minWidth: '150px' },
          {
            label: '同步类型',
            prop: 'type',
            minWidth: '150px',
            scopedSlots: {
              default: ({ row }) => this.getSyncTypeText(row.type),
            },
          },
          {
            label: '同步状态',
            prop: 'status',
            minWidth: '100px',
            scopedSlots: {
              default: ({ row }) => this.getSyncStatusText(row.status),
            },
          },
          {
            label: '是否为补偿',
            prop: 'isCompensate',
            minWidth: '100px',
            scopedSlots: {
              default: ({ row }) => (row.isCompensate === 1 ? '是' : '否'),
            },
          },
          { label: '同步执行开始时间', prop: 'createdTime', minWidth: '180px' },
        ],
        pageInfo: {
          total: 0,
          current: 1,
          size: 10,
        },
      };
    },
    computed: {
      searchData() {
        return [
          {
            comName: 'YkcDropdown',
            key: 'platformType',
            label: '订单来源',
            placeholder: '请选择同步状态',
            data: [
              { id: 1, name: '淘淘充' },
              { id: 2, name: '益虫' },
            ],
          },
          {
            comName: 'YkcDropdown',
            key: 'type',
            label: '同步类型',
            placeholder: '请选择同步状态',
            data: [
              { id: 1, name: '订单同步' },
              { id: 2, name: '支付信息同步' },
              { id: 3, name: '退款信息同步' },
            ],
          },
          {
            comName: 'YkcDropdown',
            key: 'status',
            label: '同步状态',
            placeholder: '请选择同步状态',
            data: [
              { id: 0, name: '待同步' },
              { id: 1, name: '成功' },
              { id: 2, name: '失败' },
            ],
          },
          {
            comName: 'YkcDropdown',
            key: 'isCompensate',
            label: '是否为补偿',
            placeholder: '请选择同步状态',
            data: [
              { id: 1, name: '是' },
              { id: 0, name: '否' },
            ],
          },
        ];
      },
    },
    mounted() {
      this.initData();
      this.requestList();
    },
    methods: {
      /**
       * 初始数据
       */
      initData() {
        this.tableOperateButtons = [
          {
            id: '1',
            enabled: () => code('order:charge:his:detail'),
            text: '重新同步',
            handleClick: (btn, { row }) => {
              this.handleResync(row);
            },
          },
        ];
      },

      /**
       * 列表查询
       */
      requestList() {
        const reqParams = {
          ...this.searchParams,
          ...this.pageInfo,
        };
        businessPlatform
          .getOrderSyncRecordList(reqParams)
          .then(res => {
            // 根据新的API响应格式，数据在res.data中
            this.tableData = res.records || [];
            // 如果返回的数据格式中包含total，则使用，否则默认为0
            this.pageInfo.total = res.total || 0;
          })
          .catch(err => {
            console.log(err);
          });
      },

      /**
       * 点击筛选查询按钮
       */
      handleSearchConfirm(searchData) {
        Object.assign(this.searchParams, searchData);
        this.pageInfo.current = 1;
        this.requestList();
      },

      /**
       * 点击清空查询按钮
       */
      handleSearchClean(form) {
        Object.assign(this.searchParams, form);
        this.pageInfo.current = 1;
        this.requestList();
      },

      /**
       *
       */
      handlePaginationCurrentChange(current) {
        this.pageInfo.current = current;
        this.requestList();
      },

      /**
       *
       */
      handlePaginationSizeChange(size) {
        this.pageInfo.current = 1;
        this.pageInfo.size = size;
        this.requestList();
      },

      /**
       * 导出
       */
      doExportFile() {
        offlineExport(
          {
            downloadType: 'order_sync_record',
            jsonNode: {
              ...this.searchParams,
            },
          },
          this.pageInfo.total
        );
      },

      /**
       * 获取平台类型文本
       */
      getPlatformTypeText(platformType) {
        if (platformType === undefined || platformType === null) {
          return '——';
        }

        const platformTypeMap = {
          1: '淘淘充',
          2: '益虫',
        };

        return platformTypeMap[platformType] || platformType; // 如果类型码不在映射中，返回原始值
      },

      /**
       * 获取同步状态文本
       */
      getSyncStatusText(syncStatus) {
        if (syncStatus === undefined || syncStatus === null) {
          return '——';
        }

        const syncStatusMap = {
          0: '未同步',
          1: '成功',
          2: '失败',
        };

        return syncStatusMap[syncStatus] || syncStatus; // 如果状态码不在映射中，返回原始值
      },

      /**
       * 获取同步类型文本
       */
      getSyncTypeText(syncType) {
        if (syncType === undefined || syncType === null) {
          return '——';
        }

        const syncTypeMap = {
          1: '订单同步',
          2: '支付信息同步',
          3: '退款信息同步',
        };

        return syncTypeMap[syncType] || syncType; // 如果类型码不在映射中，返回原始值
      },

      /**
       * 处理重新同步
       */
      handleResync(row) {
        this.$confirm('确认要重新同步此订单吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            businessPlatform
              .resyncOrder({ id: row.id })
              .then(() => {
                this.$message.success('重新同步成功');
                this.requestList(); // 重新加载列表
              })
              .catch(err => {
                console.error('重新同步失败:', err);
                this.$message.error('重新同步失败');
              });
          })
          .catch(() => {
            // 用户取消操作
          });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .order-sync-record-list {
    padding: 20px;
  }

  .table-header-button {
    margin-bottom: 16px;
    display: flex;
    justify-content: flex-end;
    & > * {
      margin-left: 12px;
    }
  }
</style>
